import { Mesh, MeshStandardMaterial, PlaneGeometry, } from "three";
class PlaneMeshController {
    geometry;
    material;
    mesh;
    dimensions;
    /**
     * Mesh controller that manages a simple plane mesh.
     * @param color The color of the mesh.
     * @param dimensions A 3D vector containing the size of the mesh. The Y axis is ignored.
     * @param segments A 2D vector representing the number of segments on each axis of the plane.
     * @param rotation A quaternion representing the plane's rotation.
     * @param heightmap An optional heightmap to distort the plane with.
     * @param normalmap An optional normal map to apply to the texture.
     * @param receiveShadow Whether the mesh should receive shadow.
     * @param castShadow Whether the mesh should cast shadow.
     */
    constructor(color, dimensions, segments, rotation, heightmap, normalmap, receiveShadow = true, castShadow = true) {
        this.dimensions = dimensions;
        this.material = this.createMaterial(color, normalmap);
        this.geometry = this.createGeometry(this.dimensions, rotation, segments, heightmap);
        this.mesh = this.createMesh(receiveShadow, castShadow);
    }
    /**
     * Return a vector representing the current dimensions of the mesh.
     * @returns A vector representing the dimensions of the mesh.
     */
    getDimensions() {
        return this.dimensions;
    }
    /**
     * Create a geometry object.
     * @param dimensions A 3D vector containing the size of the mesh. The Y axis is ignored.
     * @param rotation A quaternion representing the plane's rotation.
     * @param segments A 2D vector representing the number of segments on each axis of the plane.
     * @param heightmap A heightmap to distort the plane with. Optional.
     * @returns the created Geometry object.
     * @private
     */
    createGeometry(dimensions, rotation, segments, heightmap) {
        const geometry = new PlaneGeometry(dimensions.x, dimensions.z, segments.x, segments.y);
        geometry.applyQuaternion(rotation);
        if (heightmap) {
            heightmap.apply(geometry);
        }
        return geometry;
    }
    /**
     * Create a material object.
     * @param color The color of the mesh.
     * @param normalmap An optional normal map to apply to the texture.
     * @returns the created Material object.
     * @private
     */
    createMaterial(color, normalmap) {
        return new MeshStandardMaterial({ color: color, normalMap: normalmap });
    }
    /**
     * Create a mesh object.
     * @param receiveShadow Whether the mesh should receive shadow.
     * @param castShadow Whether the mesh should cast shadow.
     * @returns the created mesh object.
     * @private
     */
    createMesh(receiveShadow, castShadow) {
        const mesh = new Mesh(this.geometry, this.material);
        mesh.castShadow = castShadow;
        mesh.receiveShadow = receiveShadow;
        return mesh;
    }
    get getMesh() {
        return this.mesh;
    }
    get getGeometry() {
        return this.mesh.geometry;
    }
}
export { PlaneMeshController };
